// This file is auto-generated by @hey-api/openapi-ts

import { client } from './Client.gen';
import type { EshopCompanyCardApplicationControllerCreateCompanyCardApplicationData } from './EshopCompanyCardApplicationControllerCreateCompanyCardApplicationData.gen';
import type { EshopCompanyCardApplicationControllerCreateCompanyCardApplicationErrors } from './EshopCompanyCardApplicationControllerCreateCompanyCardApplicationErrors.gen';
import type { EshopCompanyCardApplicationControllerCreateCompanyCardApplicationResponses } from './EshopCompanyCardApplicationControllerCreateCompanyCardApplicationResponses.gen';
import type { Options } from './Options.gen';

export class EshopCompanyCardApplicationController {
    /**
     * Create a new company card application.
     */
    public static createCompanyCardApplication<ThrowOnError extends boolean = false>(options: Options<EshopCompanyCardApplicationControllerCreateCompanyCardApplicationData, ThrowOnError>) {
        return (options.client ?? client).post<EshopCompanyCardApplicationControllerCreateCompanyCardApplicationResponses, EshopCompanyCardApplicationControllerCreateCompanyCardApplicationErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/company-card-applications',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
